/**
 * 支付模块常量定义
 */

/**
 * 支付方式枚举
 */
export enum PaymentMethodEnum {
  PAYPAL = 3,
  STRIPE = 4,
}

/**
 * 支付类型（用于埋点）
 */
export enum PaymentType {
  /** 充值 */
  TOPUP = '1',
  /** 订阅 */
  SUBSCRIBE = '2',
}

/**
 * 支付方式名称映射
 */
export const PAYMENT_METHOD_NAMES: Record<number, string> = {
  [PaymentMethodEnum.PAYPAL]: 'paypal',
  [PaymentMethodEnum.STRIPE]: 'stripe',
}

/**
 * 支付方式对应的 payType
 * 用于创建订单时的参数
 */
export const PAYMENT_METHOD_PAY_TYPES: Record<number, number> = {
  [PaymentMethodEnum.PAYPAL]: 6,
  [PaymentMethodEnum.STRIPE]: 5,
}

/**
 * 充值 API 端点映射
 */
export const TOPUP_API_ENDPOINTS: Record<number, string> = {
  [PaymentMethodEnum.PAYPAL]: '/member/topup/createPaypalPaymentIntent',
  [PaymentMethodEnum.STRIPE]: '/member/topup/createStripePaymentIntent',
}

/**
 * 充值 - Stripe 内嵌（Embedded Checkout）支付意向端点
 * 返回 { data: { clientSecret, orderNum } }：
 * - clientSecret 用于 stripe.initEmbeddedCheckout({ clientSecret })
 * - orderNum 为后端业务订单号，是后续验单（verifyReceipt）的必需字段
 * 与原跳转式 createStripePaymentIntent 并存，仅 Stripe 走内嵌
 */
export const TOPUP_STRIPE_EMBEDDED_ENDPOINT = '/member/topup/stripe/embedded/createPaymentIntent'

/**
 * Stripe 支付模式开关
 * - 'hosted'：整页跳转 Stripe 官方 Checkout 收银台（版本1，无需注册业务域名，Apple/Google Pay 天然可用）
 * - 'embedded'：内嵌弹窗 Embedded Checkout（版本3，需把承载页域名注册到 Stripe）
 * 仅作用于 /pay 商店页与章节弹窗（usePurchase）；游戏内（/game）独立走 useStripeCheckout，不受此开关影响。
 */
export const STRIPE_PAY_MODE: 'hosted' | 'embedded' = 'hosted'

/**
 * 订阅 API 端点
 */
export const SUBSCRIBE_API_ENDPOINT = '/member/subscribe/createOrder'

/**
 * 商品列表 API 端点
 */
export const PRODUCT_LIST_API = {
  TOPUP: '/member/topup/v2/product/list',
  SUBSCRIBE: '/member/subscribe/v2/product/list',
}

/**
 * 支付场景
 */
export type PaymentScenario = 'store' | 'chapter'

/**
 * 默认折扣标签格式化函数
 */
export function formatDiscountLabel(maxDiscountRate?: number | string): string | null {
  if (maxDiscountRate === undefined || maxDiscountRate === null || Number(maxDiscountRate) <= 0)
    return null
  return `${Math.round(Number(maxDiscountRate))}% discount`
}
